
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.65 39.7a4.55 4.55 0 110 9.1h-8.2M54 30.6a4.55 4.55 0 010 9.1h-8.55","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M18.08 26.05c0-1.22 6.2-5.46 11-9.59 5.11-4.37 7.46-14.35 8.75-14.35 2.52 0 4.19 1.41 4.55 4.55.63 5.46-1.59 11.81-4.62 14.85h15.89a4.55 4.55 0 110 9.09h-8.2M50.31 48.8a4.55 4.55 0 010 9.09H27.17a9.09 9.09 0 01-9.09-9.09M1.49 20.5h16.58v37.39H1.49z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    